const SvgClose2 = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="m17.697 16 14.222 14.222-1.616 1.616-14.222-14.222L1.697 32 .081 30.384 14.465 16 .081 1.616 1.697 0l14.384 14.384L30.303.162l1.616 1.616z" />
  </svg>;
export default SvgClose2;